import { Reveal } from "../Reveal";
import { useLanguage } from "../../context/LanguageContext";

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 md:py-36">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <Reveal>
          <p data-testid="manifesto-label" className="text-xs font-bold tracking-[0.25em] uppercase text-brand-red mb-16 md:mb-24">
            — {t.manifesto.label}
          </p>
        </Reveal>

        <div className="flex flex-col gap-20 md:gap-28">
          {t.manifesto.chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={0.05}>
              <div
                data-testid={`manifesto-chapter-${ch.num}`}
                className={`grid md:grid-cols-12 gap-6 md:gap-10 items-start ${
                  i % 2 === 1 ? "md:text-right" : ""
                }`}
              >
                <div className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <span className="font-cabinet font-black text-7xl md:text-8xl lg:text-9xl leading-none text-stroke select-none">
                    {ch.num}
                  </span>
                </div>
                <div className={`md:col-span-8 ${i % 2 === 1 ? "md:order-1" : ""} max-w-2xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
                  <h2 className="font-cabinet font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight mb-5">
                    {ch.title}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-black/60">
                    {ch.body}
                  </p>
                  <div className={`mt-6 h-px bg-black/15 w-24 ${i % 2 === 1 ? "md:ml-auto" : ""}`} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
